import {
    LOAD_SUB_QUESTIONS_SUCCESS, RESET_SUB_QUESTIONS, REORDER_SUB_QUESTIONS_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_SUB_QUESTIONS_SUCCESS:
            return action.payload;
        case REORDER_SUB_QUESTIONS_SUCCESS:
            return action.payload;
        case RESET_SUB_QUESTIONS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/SubQuestionsReducer.js